import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MaxDurationShareButton from 'blocks/DownloadPage/components/MaxDurationShareButton';
import { TwitterButton } from 'components/SocialButton';
import useTwitterAuthenticator from 'hooks/useTwitterAuthenticator';
import { videoDurationSecondsSelector } from 'redux/modules/download';
import { hideModal, pushModal } from 'redux/modules/modal';
import { createChainedFunction } from 'utils/functions';
import useOnDownloadPageAction from '../useOnDownloadPageAction';
import { MAX_VIDEO_DURATION_SEC } from './utils';

const TwitterPostButton: React.FC = () => {
  const [shouldReauthenticate, setShouldReauthenticate] = useState<boolean>(
    false,
  );

  const videoDurationSec = useSelector(videoDurationSecondsSelector);

  const { onDownloadPageAction } = useOnDownloadPageAction();
  const dispatch = useDispatch();

  const handleError = useCallback(() => {
    setShouldReauthenticate(true);
    dispatch(hideModal());
  }, [dispatch]);

  const { authenticating, withAuthentication } = useTwitterAuthenticator({
    force: shouldReauthenticate,
    onError: handleError,
  });

  const openSocialShareModal = useCallback(() => {
    dispatch(
      pushModal({
        name: 'SocialShare',
        params: {
          platform: 'twitter',
        },
      }),
    );
  }, [dispatch]);

  return (
    <MaxDurationShareButton
      platform="X"
      videoDurationSec={videoDurationSec}
      maxVideoDurationSec={MAX_VIDEO_DURATION_SEC}
    >
      <TwitterButton
        size="small"
        params={withAuthentication}
        disabled={authenticating}
        onClick={createChainedFunction(
          () => onDownloadPageAction('twitterShare'),
          withAuthentication(openSocialShareModal),
        )}
      />
    </MaxDurationShareButton>
  );
};

export default TwitterPostButton;
